import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiChatConversationImageComponent } from '@fi-shared/fi-chat/fi-chat-conversation-image/fi-chat-conversation-image.component';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, FiProfileIconModule],
    declarations: [FiChatConversationImageComponent],
    exports: [FiChatConversationImageComponent],
})
export class FiChatConversationImageModule {}
